import { render } from "./ApplyPhoneCodeBox.vue?vue&type=template&id=f558a7b8&ts=true"
import script from "./ApplyPhoneCodeBox.vue?vue&type=script&lang=ts"
export * from "./ApplyPhoneCodeBox.vue?vue&type=script&lang=ts"

import "./ApplyPhoneCodeBox.vue?vue&type=style&index=0&id=f558a7b8&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__